import React, { useEffect } from "react";
import { Table, Switch, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useShopModel } from "../shopModel";
import { ISCMBeDetails, ISCMShopDetail } from "../shopService";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys, disableShop, editShop
    } = useShopModel();

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<ISCMShopDetail> = [
        {
            title: '序号',
            width: 60,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '分支编码',
            width: 120,
            dataIndex: 'branch',
            fixed: "left",
        }, {
            title: '门店编码',
            width: 160,
            dataIndex: 'code',
            fixed: "left",
        }, {
            title: '门店名称',
            width: 160,
            dataIndex: 'name',
        }, {
            title: '门店类型',
            width: 160,
            dataIndex: 'categoryName',
        }, {
            title: '从属机构',
            width: 160,
            dataIndex: 'orgName',
        }, {
            title: '关联实体',
            width: 160,
            dataIndex: 'details',
            render: (beDetails: ISCMBeDetails[]) => {
                if (beDetails && beDetails.length) {
                    let textVal = beDetails.map(item => item.bentityName).join();
                    // return beDetails.map(item => item.bentityName).join()
                    return <Tooltip placement="topLeft" title={textVal} arrowPointAtCenter><p style={{ width: "200px" }} className="ellipsis">{textVal}</p></Tooltip>
                }
                return ""
            }
        }, {
            title: '负责人',
            width: 160,
            dataIndex: 'contact',
        }, {
            title: '联系电话',
            width: 160,
            dataIndex: 'phone',
        }, {
            title: '币种',
            width: 160,
            dataIndex: 'currencyName',
        }, {
            title: '门店区域',
            width: 160,
            dataIndex: 'regionName',
        }, {
            title: '门店性质',
            width: 160,
            dataIndex: 'natureName',
        }, {
            title: '公司地址',
            // width: 120,
            dataIndex: 'address',
        }, {
            title: '状态',
            width: 120,
            dataIndex: 'status',
            render: (text, record) => (
                <Switch
                    checkedChildren="启用"
                    unCheckedChildren="禁用"
                    checked={+record.status ? false : true}
                    onChange={(checked: boolean, e: MouseEvent) => {
                        e.stopPropagation();
                        // disableShop(record.id, checked ? 1 : 0)
                        editShop({ ...record, status: checked ? 0 : 1 })
                    }}
                />
            ),
        }
    ];


    //点击行选高亮
    const onRow = (id: string) => {
        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === id) {
            setSelectedRowKeys([]);
        } else {
            setSelectedRowKeys([id]);
        }
    };

    return (
        <Table
            rowKey={record => record.id}
            rowSelection={{
                type: "radio",
                selectedRowKeys: selectedRowKeys, //记录选中
                onChange: (selectedRowKeys: React.Key[], selectedRows: ISCMShopDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                }
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id)
            })}
            scroll={{ x: 'max-content' }}
        />
    )
}
